
import { useEffect,useState } from "react";

import {
  getTasksApi,
  completeTaskApi,
} from "../apiServices/task.services";

const useTasks=(params={})=>{

  const [tasks,setTasks]=useState([]);
  const [loading,setLoading]=useState(false);

  const fetchTasks=async()=>{

    try{

      setLoading(true);

      const res=await getTasksApi(params);

      setTasks(res?.data || []);

    }catch(err){

      console.log(err);

    }finally{

      setLoading(false);
    }
  };

  const completeTask=async(id)=>{
    await completeTaskApi(id);
    fetchTasks();
  };

  useEffect(()=>{
    fetchTasks();
  },[JSON.stringify(params)]);

  return{
    tasks,
    loading,
    fetchTasks,
    completeTask,
  };
};

export default useTasks;
